import { create } from "zustand";
import { persist } from "zustand/middleware";

const MAX_SELECTION = 2;

const store = (set, get) => ({
  selectedDevices: [],

  setSelectedDevices: (devices) =>
    set(() => ({
      selectedDevices: devices.slice(0, MAX_SELECTION),
    })),

  toggleDeviceSelection: (device) => {
    const { selectedDevices } = get();
    const exists = selectedDevices.find((d) => d.knumber === device.knumber);

    if (exists) {
      set({
        selectedDevices: selectedDevices.filter((d) => d.knumber !== device.knumber),
      });
    } else {
      if (selectedDevices.length >= MAX_SELECTION) return;
      set({
        selectedDevices: [...selectedDevices, device],
      });
    }
  },

  clearSelectedDevices: () => set({ selectedDevices: [] }),
});

export const usePDDSelectedDeviceStore = create(
  persist(store, { name: "pdd-devices-selected-presub" }),
);
